import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// component items
import { CoreNotificationsHelpersEventVersionStatusUpdateSuccessComponent } from './version-status-update-success/version-status-update-success.component';
import { CoreNotificationsHelpersEventVersionStatusUpdateFailedComponent } from './version-status-update-failed/version-status-update-failed.component';
import { CoreNotificationsHelpersEventDefaultFailedComponent } from './deafult-failed/default-failed.component';
import { CoreNotificationsHelpersEventFileAnnotationsUpdateFailedComponent } from './file-annotations-update-failed/file-annotations-update-failed.component';

// components

@NgModule({
    imports: [
        CommonModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        CoreNotificationsHelpersEventVersionStatusUpdateSuccessComponent,
        CoreNotificationsHelpersEventVersionStatusUpdateFailedComponent,
        CoreNotificationsHelpersEventDefaultFailedComponent,
        CoreNotificationsHelpersEventFileAnnotationsUpdateFailedComponent
    ],
    exports: [
        CoreNotificationsHelpersEventVersionStatusUpdateSuccessComponent,
        CoreNotificationsHelpersEventVersionStatusUpdateFailedComponent,
        CoreNotificationsHelpersEventDefaultFailedComponent,
        CoreNotificationsHelpersEventFileAnnotationsUpdateFailedComponent
    ],

})
export class CoreNotificationsHelpersEventsModule { }
// Module for notification helpers components for each events notification
